/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanyProfileStatusEnum = 'Erstellt' | 'AktivierungAngefordert' | 'Aktiviert' | 'DeaktivierungAngefordert' | 'Deaktiviert' | 'Abgelaufen';

export const CompanyProfileStatusEnum = {
    Erstellt: 'Erstellt' as CompanyProfileStatusEnum,
    AktivierungAngefordert: 'AktivierungAngefordert' as CompanyProfileStatusEnum,
    Aktiviert: 'Aktiviert' as CompanyProfileStatusEnum,
    DeaktivierungAngefordert: 'DeaktivierungAngefordert' as CompanyProfileStatusEnum,
    Deaktiviert: 'Deaktiviert' as CompanyProfileStatusEnum,
    Abgelaufen: 'Abgelaufen' as CompanyProfileStatusEnum
};

